// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es7.math.rad-per-deg.js
// module id = 1024
// module chunks = 0